/* @flow */

// $FlowFixMe
module.exports = require('./dist/belter'); // eslint-disable-line import/no-commonjs
